import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-aba-sorvete-cadastro-produtos',
  templateUrl: './aba-sorvete-cadastro-produtos.component.html',
  styleUrls: ['./aba-sorvete-cadastro-produtos.component.css']
})
export class AbaSorveteCadastroProdutosComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
